import React from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

const SettingsPageHeader = () => {
  const location = useLocation();

  return (
    <div>
      <div className="settings-page-head">
        <ul className="settings-pg-links">
          <li>
            <Link
              to="/profile-settings"
              className={`settings-tab-link ${location.pathname === "/profile-settings" ? "active text-darkfume text-sm" : "text-fume text-sm"}`}
            > 
              <i className="bx bx-edit" />
              Profili Düzenle
            </Link>
          </li>
          <li>
            <Link
              to="/profile-change-password"
              className={`settings-tab-link ${location.pathname === "/profile-change-password" ? "active text-darkfume text-sm" : "text-fume text-sm"}`}
            >
              <i className="bx bx-lock" />
              Şifreyi Değiştir
            </Link>
          </li>
          <li>
            {/* <Link
              to="/profile-settings-format"
              className={`settings-tab-link ${location.pathname === "/profile-settings-format" ? "active text-darkfume text-sm" : "text-fume text-sm"}`}
            >
              <i className="bx bx-lock" />
             Kullanıcı Ayarları
            </Link> */}
          </li>
       
      
        </ul>
      </div>
    </div>
  );
};

export default SettingsPageHeader;
